<template>
  <div>
    <section :class="['section', 'industries-carousel', { 'has-heading' : hasHeading}]">
      <h4 v-if="hasHeading" class="title has-text-weight-bold" v-html="heading"></h4>
      <p v-if="industries_loading" class="has-text-centered spinner"><img src="/static/img/spinner.svg" alt="Loading industries" /></p>
      <!-- desktop carousel -->
      <carousel class="is-hidden-mobile is-hidden-tablet-only"  v-if="!industries_loading" :navigation-enabled="navigationEnabled" :pagination-enabled="paginationEnabled" :per-page="industriesPerPageDesktop" :scroll-per-page="scrollPerPage">
        <slide v-for="record in industries" :key="record.industry_id">
          <div class="card">
            <div class="card-content">
              <div class="content">
                <h4 class="has-text-weight-bold"><router-link :to="`/industries/${record.industry_slug}`" v-html="record.industry_name"></router-link></h4>
                <div class="level" v-for="(business, index) in record.businesses">
                  <div class="level-left">
                    <div class="level-item">
                      <router-link :to="`/${business.slug}`" v-html="numberedName(index, business.name)"></router-link>
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item">
                      <router-link class="has-text-weight-bold" :to="`/${business.slug}`" v-html="business.trust_index"></router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </slide>
      </carousel>
      <!-- tablet carousel -->
      <carousel class="is-hidden-mobile is-hidden-desktop"  v-if="!industries_loading" :navigation-enabled="navigationEnabled" :pagination-enabled="paginationEnabled" :per-page="industriesPerPageTablet" :scroll-per-page="scrollPerPage">
        <slide v-for="record in industries" :key="record.industry_id">
          <div class="card">
            <div class="card-content">
              <div class="content">
                <h4 class="has-text-weight-bold"><router-link :to="`/industries/${record.industry_slug}`" v-html="record.industry_name"></router-link></h4>
                <div class="level" v-for="(business, index) in record.businesses">
                  <div class="level-left">
                    <div class="level-item">
                      <router-link :to="`/${business.slug}`" v-html="numberedName(index, business.name)"></router-link>
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item">
                      <router-link class="has-text-weight-bold" :to="`/${business.slug}`" v-html="business.trust_index"></router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </slide>
      </carousel>
      <!-- mobile carousel -->
      <carousel class="is-hidden-tablet"  v-if="!industries_loading" :navigation-enabled="navigationEnabled" :pagination-enabled="paginationEnabled" :per-page="industriesPerPageMobile" :scroll-per-page="scrollPerPage">
        <slide v-for="record in industries" :key="record.industry_id">
          <div class="card">
            <div class="card-content">
              <div class="content">
                <h4 class="has-text-weight-bold"><router-link :to="`/industries/${record.industry_slug}`" v-html="record.industry_name"></router-link></h4>
                <div class="level is-mobile" v-for="(business, index) in record.businesses">
                  <div class="level-left">
                    <div class="level-item">
                      <router-link :to="`/${business.slug}`" v-html="numberedName(index, business.name)"></router-link>
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item">
                      <router-link class="has-text-weight-bold" :to="`/${business.slug}`" v-html="business.trust_index"></router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </slide>
      </carousel>
    </section>
  </div>
</template>
<script>
  import axios from 'axios'

  export default {
    name: 'IndustryCarousel',
    props: {
      heading: {
        type: String,
        default: ''
      }
    },
    created () {
      this.getTopBusinessesPerIndustry()
    },
    data () {
      return {
        industries: [],
        industries_loading: true,
        industriesPerPageDesktop: 4,
        industriesPerPageTablet: 2,
        industriesPerPageMobile: 1,
        navigationEnabled: true,
        paginationEnabled: false,
        scrollPerPage: false
      }
    },
    computed: {
      hasHeading () {
        return this.heading.length > 0
      }
    },
    methods: {
      getTopBusinessesPerIndustry () {
        this.industries_loading = true
        axios.get('/consumer/industries/top-business-by-industry')
          .then(({data}) => {
            let tmp = data
            tmp.sort((a, b) => (a.total_reviews < b.total_reviews) ? 1 : ((b.total_reviews < a.total_reviews) ? -1 : 0))
            this.industries = tmp
            this.industries_loading = false
            this.$emit('industry-carousel-loaded')
          })
          .catch(() => {
            this.industries_loading = false
          })
      },
      numberedName (index, businessName) {
        return `${index + 1}. ${businessName}`
      },
    }
  }
</script>
<style scoped>
  .industries-carousel {
    padding-top: 5rem;
    padding-bottom: 5rem;
    background-color: #F5F5F5;
  }

  .industries-carousel.has-heading {
    background-color: #ffffff;
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .industries-carousel .VueCarousel, .industries-carousel > h4 {
    max-width: 1140px;
    margin: 0 auto;
  }

  .industries-carousel > h4 {
    max-width: 1100px;
    font-size: 1.3rem;
    color: #58595B;
    margin-bottom: 2rem!important;
  }

  .industries-carousel .VueCarousel .card {
    margin: 0 auto;
    width: 260px;
    border: 1px solid #C9C9C9;
    background-color: #ffffff;
    box-shadow: none;
  }

  .industries-carousel .VueCarousel .card > .card-content {
    padding: 1.5rem 0.8rem 2rem 0.8rem;
  }

  .industries-carousel .VueCarousel .card > .card-content > .content > h4 {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 1rem;
    margin-bottom: 1.4rem;
    color: #31AAE1;
  }

  .industries-carousel .VueCarousel .card > .card-content > .content > h4 > a, .industries-carousel .VueCarousel .card > .card-content > .content > h4 > a:visited {
    color: #31AAE1;
    text-decoration: none;
  }

  .industries-carousel .VueCarousel .card .level:not(:last-child) {
    margin-bottom: 0.6rem;
  }

  .industries-carousel .VueCarousel .card > .card-content > .content > .level a, .industries-carousel .VueCarousel .card > .card-content > .content > .level a:visited, .industries-carousel .VueCarousel .card > .card-content > .content > .level a:hover {
    text-decoration: none;
    color: #58595B;
    font-size: 0.9rem;
  }

  .industries-carousel .VueCarousel .card .level-left, .industries-carousel .VueCarousel .card .level-item, .industries-carousel .VueCarousel .card .level-item > a {
    overflow: hidden;
    max-width: 180px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  @media screen and (max-width: 1024px) {
    .industries-carousel > h4 {
      padding-left: 0.5rem;
    }

    .industries-carousel .VueCarousel .card {
      width: 345px;
    }

    .industries-carousel .VueCarousel .card .level-left, .industries-carousel .VueCarousel .card .level-item, .industries-carousel .VueCarousel .card .level-item > a {
      max-width: 225px;
    }
  }

  @media screen and (max-width: 767px) {
    .industries-carousel > h4 {
      padding-left: 0;
    }

    .industries-carousel .VueCarousel .card {
      /*width: 275px;*/
      width: calc(100vw - 50px);
    }

    .industries-carousel .VueCarousel .card .level-left {
      width: 90%;
      max-width: 90%;
    }

    .industries-carousel .VueCarousel .card .level-left > .level-item > a {
      width: 100%;
      max-width: 100%;
    }

    .industries-carousel .VueCarousel .card .level-left > .level-item {
      width: 100%;
      max-width: 100%;
    }

    .industries-carousel .VueCarousel .card .level-right {
      width: 30px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/IndustryCarousel.vue